import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationService } from './shared/services/notification.service';
import { LocalizeDirective } from './core/localization/localize.directive';
import { LocalizationService } from './core/localization/localization.service';
import { AuthService } from './core/auth/auth.service';
@Component({
  selector: 'ss-root',
  standalone: true,
  imports: [RouterOutlet, LocalizeDirective],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly notifications = inject(NotificationService);
  private readonly auth = inject(AuthService);
  private readonly localization = inject(LocalizationService);

  constructor() {
    // Apply the signed-in user's stored preference. Runs on login, on refresh,
    // and again whenever the language picker refreshes the current user.
    effect(() => {
      const preferred = this.auth.currentUser()?.preferredLanguage;
      this.localization.use(preferred);
    });
  }
}
